function SocialIcons() {
  return (
    <div className="social-icons col-xl-4">
        <a href="https://www.youtube.com/@schism15"><img height="32" src="youtube_social_icon.png" /></a>
        <a href="https://twitter.com/_schism15"><img height="32" src="twitter_social_icon.svg" /></a>
    </div>
  );
}

export default SocialIcons;